var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#7029a3",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16 18.333c0.5467 0 1-0.4534 1-1v-6.6667c0-0.5467-0.4533-1-1-1s-1 0.45331-1 1v6.6667c0 0.5466 0.4533 1 1 1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m17.226 20.826c-0.0667-0.16-0.16-0.3066-0.28-0.44-0.1333-0.12-0.28-0.2133-0.44-0.28-0.32-0.1333-0.6933-0.1333-1.0133 0-0.16 0.0667-0.3067 0.16-0.44 0.28-0.12 0.1334-0.2134 0.28-0.28 0.44-0.0667 0.16-0.1067 0.3334-0.1067 0.5067s0.04 0.3467 0.1067 0.5067c0.0666 0.1733 0.16 0.3066 0.28 0.44 0.1333 0.12 0.28 0.2133 0.44 0.28 0.16 0.0666 0.3333 0.1066 0.5066 0.1066 0.1734 0 0.3467-0.04 0.5067-0.1066 0.16-0.0667 0.3067-0.16 0.44-0.28 0.12-0.1334 0.2133-0.2667 0.28-0.44 0.0667-0.16 0.1067-0.3334 0.1067-0.5067s-0.04-0.3467-0.1067-0.5067z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfo);
export default __webpack_public_path__ + "static/media/icon_info.10a7edc11dd3069e122800e3eacc9018.svg";
export { ForwardRef as ReactComponent };